export default __webpack_public_path__ + "static/media/eth-blue.a74b6ff6.svg";